import { BaseAPI, Configuration } from "./index";

export interface NotificationPreferenceDto {
  iduserNotificationPreference: number;
  iduser: number;
  idnotificationType: number;
  notificationTypeCode: string;
  notificationTypeLibelle: string;
  emailEnabled: boolean;
  pushEnabled: boolean;
  emailDisabled: boolean;
}

export class NotificationPreferenceApi extends BaseAPI {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;

  constructor(
    configuration: Configuration,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  getAll(): Promise<NotificationPreferenceDto[]> {
    let url_ = this.baseUrl + "/api/NotificationPreference";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(
          url_,
          _response,
          (_response: Response) => this.processGetAll(_response)
        );
      });
  }

  protected processGetAll(
    response: Response
  ): Promise<NotificationPreferenceDto[]> {
    const status = response.status;
    if (status === 200) {
      return response.text().then((_responseText) => {
        return _responseText === ""
          ? null
          : JSON.parse(_responseText);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        throw new Error(
          "An unexpected server error occurred: " + _responseText
        );
      });
    }
    return Promise.resolve<NotificationPreferenceDto[]>(null as any);
  }

  save(
    dto: NotificationPreferenceDto
  ): Promise<NotificationPreferenceDto> {
    let url_ = this.baseUrl + "/api/NotificationPreference";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(
          url_,
          _response,
          (_response: Response) => this.processSave(_response)
        );
      });
  }

  protected processSave(
    response: Response
  ): Promise<NotificationPreferenceDto> {
    const status = response.status;
    if (status === 200) {
      return response.text().then((_responseText) => {
        return _responseText === ""
          ? null
          : JSON.parse(_responseText);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        throw new Error(
          "An unexpected server error occurred: " + _responseText
        );
      });
    }
    return Promise.resolve<NotificationPreferenceDto>(null as any);
  }
}
